var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM15.0391 9.02344C15.4062 9.39062 15.4062 9.98438 15.0391 10.3477C14.6719 10.7109 14.0781 10.7148 13.7148 10.3477L10.9414 7.57422V14.6875C10.9414 15.207 10.5234 15.625 10.0039 15.625C9.48438 15.625 9.06641 15.207 9.06641 14.6875V7.57422L6.29297 10.3477C5.92578 10.7148 5.33203 10.7148 4.96875 10.3477C4.60547 9.98047 4.60156 9.38672 4.96875 9.02344L9.33594 4.64844C9.70312 4.28125 10.2969 4.28125 10.6602 4.64844L15.0391 9.02344Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledArrowUp);
export default __webpack_public_path__ + "static/media/icon-filled-arrow-up.7e684f030821d2d7b3a7245a0cf0bbaf.svg";
export { ForwardRef as ReactComponent };